import { ShoppingCart, RefreshCw, Share2, Check } from 'lucide-react'

type Props = {
  mode:             'browse' | 'shopping'
  itemCount:        number
  onStartShopping:  () => void
  onFinishShopping: () => void
  onRegenerate:     () => void
  onShare:          () => void
  regenerating?:    boolean
}

export function ListActionFooter({
  mode,
  itemCount,
  onStartShopping,
  onFinishShopping,
  onRegenerate,
  onShare,
  regenerating,
}: Props) {
  const isShopping    = mode === 'shopping'
  const primaryClick  = isShopping ? onFinishShopping : onStartShopping
  const primaryLabel  = isShopping ? 'Done shopping'  : 'Start shopping'
  const PrimaryIcon   = isShopping ? Check            : ShoppingCart
  const startDisabled = !isShopping && itemCount === 0

  return (
    <div className="sticky bottom-4 z-10 pt-3 bg-gradient-to-b from-transparent via-cream/80 to-cream">
      <button
        onClick={primaryClick}
        disabled={startDisabled}
        className="w-full rounded-[14px] bg-forest p-[14px] mb-2 text-[14px] font-bold tracking-[-0.01em] text-forest-ink disabled:opacity-50 flex items-center justify-center gap-1.5"
      >
        <PrimaryIcon className="h-[14px] w-[14px]" strokeWidth={1.8} />
        {primaryLabel}
      </button>
      <div className="flex gap-1.5">
        <button
          onClick={onRegenerate}
          disabled={regenerating || isShopping}
          className="flex-1 rounded-[12px] border border-border-sand bg-paper py-[11px] text-[12px] font-semibold text-ink flex items-center justify-center gap-1.5 disabled:opacity-50"
        >
          <RefreshCw
            className={`h-[13px] w-[13px] text-forest ${regenerating ? 'animate-spin' : ''}`}
            strokeWidth={1.7}
          />
          Regenerate
        </button>
        <button
          onClick={onShare}
          className="flex-1 rounded-[12px] border border-border-sand bg-paper py-[11px] text-[12px] font-semibold text-ink flex items-center justify-center gap-1.5"
        >
          <Share2 className="h-[13px] w-[13px] text-forest" strokeWidth={1.7} />
          Send to shopper
        </button>
      </div>
    </div>
  )
}
